import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { formatNumber } from 'UI/utils';

import {
  BodyCell,
  BodyHeaderCell,
  BodyRow,
  Container,
  DarkHeaderCell,
  TopHeaderCell
} from './CallSummaryTable.styled';

const COPIES = strings.phoneDashboard.sections.callSummaryTable;

export const CallSummaryTable = ({
  grandTotal = 0,
  inboundConnected = 0,
  inboundMissed = 0,
  outboundConnected = 0,
  outboundNotConnected = 0
}) => {
  return (
    <Container elevation={0} aria-label="call summary table">
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TopHeaderCell />
              <TopHeaderCell colSpan={2}>
                <Typography variant="subtitle2">{COPIES.primaryHeaders.outbound}</Typography>
              </TopHeaderCell>
              <TopHeaderCell colSpan={2}>
                <Typography variant="subtitle2">{COPIES.primaryHeaders.inbound}</Typography>
              </TopHeaderCell>
              <TopHeaderCell>
                <Typography variant="subtitle2">{COPIES.primaryHeaders.grandTotal}</Typography>
              </TopHeaderCell>
            </TableRow>

            <TableRow>
              <DarkHeaderCell>
                <Typography variant="subtitle2">{COPIES.secondaryHeaders.callResult}</Typography>
              </DarkHeaderCell>
              <DarkHeaderCell>
                <Typography variant="subtitle2">{COPIES.secondaryHeaders.connected}</Typography>
              </DarkHeaderCell>
              <DarkHeaderCell>
                <Typography variant="subtitle2">{COPIES.secondaryHeaders.notConnected}</Typography>
              </DarkHeaderCell>
              <DarkHeaderCell>
                <Typography variant="subtitle2">{COPIES.secondaryHeaders.connected}</Typography>
              </DarkHeaderCell>
              <DarkHeaderCell>
                <Typography variant="subtitle2">{COPIES.secondaryHeaders.missed}</Typography>
              </DarkHeaderCell>
              <DarkHeaderCell />
            </TableRow>
          </TableHead>

          <TableBody>
            <BodyRow hover>
              <BodyHeaderCell>
                <Typography variant="subtitle2">{COPIES.secondaryHeaders.total}</Typography>
              </BodyHeaderCell>
              <BodyCell>
                <Typography variant="body2">{formatNumber(outboundConnected)}</Typography>
              </BodyCell>
              <BodyCell>
                <Typography variant="body2">{formatNumber(outboundNotConnected)}</Typography>
              </BodyCell>
              <BodyCell>
                <Typography variant="body2">{formatNumber(inboundConnected)}</Typography>
              </BodyCell>
              <BodyCell>
                <Typography variant="body2">{formatNumber(inboundMissed)}</Typography>
              </BodyCell>
              <BodyCell>
                <Typography variant="body2">{formatNumber(grandTotal)}</Typography>
              </BodyCell>
            </BodyRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};
